import React from 'react'
import { Link } from 'react-router-dom'

export function Person({ person, id }) {
  if (!id) return <>—</>
  return person?.id ? <Link to={`/accounts/players/${person.id}`}>{person.firstName} {person.lastName} #{id}</Link> : <>#{id}</>
}
export function Answer({ value, t }) {
  if (value?.kind === 'cannot-assess') return <>{t('cannotAssess')}</>
  if (value?.kind === 'level') return <>{t('levelValue', { value: value.level })}</>
  return <>{value ?? '—'}</>
}
export function Reason({ reason, t }) {
  return <>{reason ? t([`reason_${reason}`, 'reason_unknown']) : '—'}</>
}
export function Source({ row, t }) {
  const competitions = row.sourceCompetitions?.length ? row.sourceCompetitions : row.competitionId ? [{ id: row.competitionId, gameType: row.gameType }] : []
  if (row.eventId) return <>
    {row.sourceScope === 'author-draws' && <small className="d-block text-muted">{t('authorDraws')}</small>}
    {competitions.map(competition => <Link key={competition.id} className="d-block" to={'/events/' + row.eventId + '/competitions/' + competition.id + '/matches'}>
      {t('mainDraw')}{competition.level != null && ' · ' + t('levelValue', { value: competition.level })}{competition.gameType && ' · ' + t(competition.gameType)}
    </Link>)}
    {!competitions.length && <><small className="d-block">{t('drawUnavailable')}</small><Link to={'/events/' + row.eventId + '/competitions'}>{t('eventCompetitions')}</Link></>}
  </>
  return row.sourceType === 'friendly' && row.sourceId ? <Link to={'/friendly-matches/' + row.sourceId}>{t('friendly')}</Link> : <>{t('unknown')}</>
}
export function Pagination({ data, onPage, t }) {
  if (!data || data.total <= data.limit) return null
  return <div className="d-flex align-items-center gap-10 mt-3">
    <button type="button" className="btn btn-secondary" disabled={data.page <= 1} onClick={() => onPage(data.page - 1)}>{t('previous')}</button>
    <span>{t('page', { page: data.page, pages: Math.ceil(data.total / data.limit), total: data.total })}</span>
    <button type="button" className="btn btn-secondary" disabled={data.page * data.limit >= data.total} onClick={() => onPage(data.page + 1)}>{t('next')}</button>
  </div>
}
export function LoadState({ state, t }) {
  return <>{state.loading && <p role="status">{t('loading')}</p>}
    {state.error && <div role="alert">{t('error')} <button type="button" className="btn btn-link" onClick={state.retry}>{t('retry')}</button></div>}</>
}
export function AuditRows({ rows, onDetail, t, eventContext = false }) {
  if (!rows.length) return <p>{t('empty')}</p>
  return <div className="table-responsive"><table className="table table-striped">
    <thead><tr>{['author', 'player', 'sportFormat', 'answer', 'source', ...(eventContext ? [] : ['eligibility']), 'audit'].map(key => <th scope="col" key={key}>{t(key)}</th>)}</tr></thead>
    <tbody>{rows.map(row => <tr key={row.id}>
      <td><Person person={row.author} id={row.authorId} /></td><td><Person person={row.receiver} id={row.receiverUserId} /></td>
      <td>{t(row.sportType || 'unknown')} / {row.gameType ? t(row.gameType) : '—'}</td>
      <td><Answer value={row.value} t={t} />{eventContext && row.eligibility !== 'active' && <small className="d-block text-muted">{t('inactive')}</small>}{row.signal && <small className="d-block">{t('signal', { median: row.median, count: row.numericCount })}</small>}</td>
      <td><Source row={row} t={t} /></td>{!eventContext && <td>{t(row.eligibility)}{row.reason && <small className="d-block"><Reason reason={row.reason} t={t} /></small>}</td>}
      <td><button type="button" className="btn btn-link p-0" onClick={() => onDetail(row)}>{t('viewAudit')}</button></td>
    </tr>)}</tbody>
  </table></div>
}
